import { render, staticRenderFns } from "./LanguageAddForm.vue?vue&type=template&id=00dad6b4"
import script from "./LanguageAddForm.vue?vue&type=script&lang=js"
export * from "./LanguageAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports